import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class CommissionLineDetailSearchParams extends SearchParamsBase {
  static saveType = 'CommissionLineDetailSearchParams';
  initialize() {
    this.SelectedUserIds = [];
    this.SelectedExternalSalesPartnerId = null;
    this.UserIds = [];
    this.ClientIds = [];
    this.OpportunityIds = [];
    this.ServiceIds = [];
    this.SourceType = '';
    this.SourceId = '';
    this.SourceLineType = '';
    this.RevenuePeriods = '';
  }

  static getSourceTypeValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Client Invoice', value: 'Client Invoice', disabled: false },
      { label: 'Credit Memo', value: 'Credit Memo', disabled: false },
      { label: 'Third-Party Client Invoice', value: 'Third-Party Client Invoice', disabled: false },
      { label: 'Third-Party Credit Memo', value: 'Third-Party Credit Memo', disabled: false },
      { label: 'Manual', value: 'Manual', disabled: false },
    ];
  }

  static getSourceLineTypeValues() {
    return [
      { label: '', value: '', disabled: false },
      { label: 'Invoice Line', value: 'Invoice Line', disabled: false },
      { label: 'Assignment Line', value: 'Assignment Line', disabled: false },
      { label: 'Credit Line', value: 'Credit Line', disabled: false },
      { label: 'Third-Party Invoice Line', value: 'Third-Party Invoice Line', disabled: false },
      { label: 'Third-Party Assignment Line', value: 'Third-Party Assignment Line', disabled: false },
      { label: 'Third-Party Credit Line', value: 'Third-Party Credit Line', disabled: false },
    ];
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    {
      fieldName: 'ClientIds',
      label: 'Client',
      className: 'col-4',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      fieldName: 'OpportunityIds',
      label: 'Opportunity',
      className: 'col-4',
      type: InputTypesEnum.OpportunityMultiChoice,
      idFilter: (item) => item.ClientIds,
      disabled: (item) => !item.ClientIds || item.ClientIds.length === 0,
    },
    {
      fieldName: 'ServiceIds',
      label: 'Service',
      className: 'col-4',
      type: InputTypesEnum.ServiceMultiChoice,
      idFilter: (item) => item.OpportunityIds,
      disabled: (item) => !item.OpportunityIds || item.OpportunityIds.length === 0,
    },
    {
      fieldName: 'SelectedUserIds',
      label: 'User',
      className: 'col-4',
      type: InputTypesEnum.CommissionUserMultiChoice,
    },
    {
      fieldName: 'SelectedExternalSalesPartnerId',
      label: 'External Sales Partner',
      className: 'col-4',
      type: InputTypesEnum.ExternalSalesPartnerSelect,
    },
    {
      fieldName: 'SourceType',
      label: 'Source Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: CommissionLineDetailSearchParams.getSourceTypeValues(),
    },
    {
      fieldName: 'SourceId',
      label: 'Source ID',
      className: 'col-4',
      type: InputTypesEnum.Number,
    },
    {
      fieldName: 'SourceLineType',
      label: 'Source Line Type',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: CommissionLineDetailSearchParams.getSourceLineTypeValues(),
    },
    {
      fieldName: 'RevenuePeriods',
      label: 'Revenue Period (YRMO1,YRMO2...)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
  ];
}
